initFlexMedia();

function initFlexMedia() {
  const mediaBlocks = document.querySelectorAll("[data-flex-media]");
  if (!mediaBlocks.length) return;

  mediaBlocks.forEach((block) => {
    const playButton = block.querySelector("[data-flex-media-play]");
    const video = block.querySelector("video");
    if (!playButton || !video) return;

    playButton.addEventListener("click", async () => {
      block.classList.add("is-playing");
      video.controls = true;

      try {
        await video.play();
      } catch (error) {
        block.classList.remove("is-playing");
      }
    });
  });
}
